<template>
    <div>
        <button class="btn btn-sm btn-primary"  data-toggle="modal" data-target="#internal-acts-popup" key="internal-acts-popup"><i class="fas fa-plus"></i> No IK akta</button>
        <div class="modal fade" tabindex="-1"  id="internal-acts-popup" ref="vuemodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Iekšējās kustības akti</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="lists">Iekšējās kustības akti</label>
                                    <select name="internal_act_id" id="internal_act_id" v-model="selected_internal_act_id" class="form-control">
                                        <option v-for="act in internal_acts" :key="'act-'+act.id" :value="act.id">
                                            {{act.act_number}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12 text-center">
                                <button class="btn btn-sm btn-primary" @click="addItemsToList(selected_internal_act_id)" v-if="selected_internal_act_id">Pievienot priekšmetus sarakstam</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    mounted()
    {
        this.getInternalActsList();
    },
    data()
    {
        return{
            internal_acts:[],
            selected_internal_act_id:"",
        }
    },
    methods:{
        getInternalActsList(){
            var that = this;
            axios.post('/internal-acts/get-acts-list').then(response =>{
                if(response.data.status == 'ok')
                {
                    that.internal_acts = response.data.acts;
                }
            })
        },
        addItemsToList(id) {
            axios.post('/internal-acts/get-act-item-ids',{
                id: id
            }).then(response =>{
                EventBus.$emit('add_items_to_list',response.data.items_ids);
            })
        }

    }
}
</script>
